import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="frontend--map"
// Loads the map only once a visitor asks for it, so Google is not contacted
// (and sets no cookies) on a page nobody interacts with.
export default class extends Controller {
  static targets = ["notice", "button"]
  static values = { url: String, title: String }

  show() {
    const frame = document.createElement("iframe")
    frame.src = this.urlValue
    frame.title = this.titleValue
    frame.loading = "lazy"
    frame.className = "absolute inset-0 w-full h-full rounded-base border-0"

    this.element.appendChild(frame)
    if (this.hasNoticeTarget) this.noticeTarget.remove()
    if (this.hasButtonTarget) this.buttonTarget.remove()
  }
}
